// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeacherComponents
{
    width: 100%;
    height: auto;
    padding: 1%;
}
.TeacherBankDetails,.TeacherPersonalDetails
{
    width: 30%;
    height: auto;
    background-color: #d3e3da;
    padding: 3%;
    float: left;
    border-radius: 2vh;

}
.TeacherpersonalDetails
{
    width: 30%;
}

.TeacherINP,.TeacherInp
{
    width: 60%;
    height: auto;
    border: 0;
    border-radius: 1vh;
    margin:  2% 2% 2% 5%;
    padding: 2%;
}
 
.BankBtn,.btn1,.btn2
{
    padding: 3% 6% 3% 6%;
    background-color:#03b4c6;
    font-weight: bold;
    color: white;
    font-family: sans-serif;
    border: 0;
    border-radius: 1vh;
    margin-left: 15%;
}
.btn1
{
    margin-left: 2%;
}
.btn2
{
    margin-left: 15%;

}
/* .btn:hover{
    background-color:white ;
    color:#03b4c6 ;
} */

.edit-bar{
    min-width: auto;
    order: 2;
    min-height: auto; 
    height: max-content;
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
    height: auto;
    align-items: center;
    justify-content: center;
 
    background-color: rgb(0, 100, 128);


}
.edit-heading{
    margin-left: 40%;
    width: auto;
    height: auto;
    flex-grow: 1;
    font-family: "Open Sans";
    font-size: 50px;
    font-weight: 300;
    color: rgb(255, 255, 255);
    line-height: 1.3;
    border-radius: 0px;
} 

.meetLink,.courses
{
    width: 65%;
    padding: 0 8px 0 2%;
    height: auto;
    float: right;
    margin-left: 1px;
    background-color:#d3e3da ;
}
.courses
{
    margin-top: 2%;
    padding: 2% 3% 2% 3%;

}
.monday
{
    padding:  2% 4% 2% 4%;
    border-radius: 2vh;
    margin-left: 1%;
    margin-bottom: 1%;
}
.EditTecherInp 
{
    width: 100%;
    padding: 1vh 1vh 1vh 1vh;
    margin: 0px 1vh 0px 1vh;
    border-radius: 2vh;
    height: auto;
    border: 0;    
}
.DegreeUpload{
    display: flex;
    width: 40%;
    height: 10%;
    border-radius: 1vh;
    border: 2px dotted;
    padding: 2%;
    background-color:rgb(238, 237, 237);
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.education
{
    display: flex;
    flex-wrap: wrap;
    width: 50%;
}
.EditTecherInp{
    margin: 1vh 0 1vh 0;
}

.tableInfo
{
    display: flex;
    background-color: #34979c;
    height: auto;
    width: 94%;
    margin-left: 4%;
    border-radius: 2vh;
}
@media screen and (max-width: 1000px) 
  {
      .edit-heading
      {
          text-align: center;
          margin-left: 0;
      }
      .TeacherComponents
      {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .TeacherBankDetails,.meetLink,.courses,.TeacherPersonalDetails
      {
        width: auto;
        margin: 2% 0 2% 0;
      }


    
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/Teacher.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;;AAEtB;AACA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,oBAAoB;IACpB,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,gBAAgB;;AAEpB;AACA;;;GAGG;;AAEH;IACI,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;IAEvB,kCAAkC;;;AAGtC;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;;IAEI,cAAc;IACd,oBAAoB;;AAExB;AACA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;;IAEI,WAAW;IACX,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;AACA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI,aAAa;IACb,eAAe;IACf,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;AACA;;MAEM;;UAEI,kBAAkB;UAClB,cAAc;MAClB;MACA;;QAEE,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;MACzB;MACA;;QAEE,WAAW;QACX,iBAAiB;MACnB;;;;AAIN","sourcesContent":[".TeacherComponents\n{\n    width: 100%;\n    height: auto;\n    padding: 1%;\n}\n.TeacherBankDetails,.TeacherPersonalDetails\n{\n    width: 30%;\n    height: auto;\n    background-color: #d3e3da;\n    padding: 3%;\n    float: left;\n    border-radius: 2vh;\n\n}\n.TeacherpersonalDetails\n{\n    width: 30%;\n}\n\n.TeacherINP,.TeacherInp\n{\n    width: 60%;\n    height: auto;\n    border: 0;\n    border-radius: 1vh;\n    margin:  2% 2% 2% 5%;\n    padding: 2%;\n}\n \n.BankBtn,.btn1,.btn2\n{\n    padding: 3% 6% 3% 6%;\n    background-color:#03b4c6;\n    font-weight: bold;\n    color: white;\n    font-family: sans-serif;\n    border: 0;\n    border-radius: 1vh;\n    margin-left: 15%;\n}\n.btn1\n{\n    margin-left: 2%;\n}\n.btn2\n{\n    margin-left: 15%;\n\n}\n/* .btn:hover{\n    background-color:white ;\n    color:#03b4c6 ;\n} */\n\n.edit-bar{\n    min-width: auto;\n    order: 2;\n    min-height: auto; \n    height: max-content;\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 100%;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n \n    background-color: rgb(0, 100, 128);\n\n\n}\n.edit-heading{\n    margin-left: 40%;\n    width: auto;\n    height: auto;\n    flex-grow: 1;\n    font-family: \"Open Sans\";\n    font-size: 50px;\n    font-weight: 300;\n    color: rgb(255, 255, 255);\n    line-height: 1.3;\n    border-radius: 0px;\n} \n\n.meetLink,.courses\n{\n    width: 65%;\n    padding: 0 8px 0 2%;\n    height: auto;\n    float: right;\n    margin-left: 1px;\n    background-color:#d3e3da ;\n}\n.courses\n{\n    margin-top: 2%;\n    padding: 2% 3% 2% 3%;\n\n}\n.monday\n{\n    padding:  2% 4% 2% 4%;\n    border-radius: 2vh;\n    margin-left: 1%;\n    margin-bottom: 1%;\n}\n.EditTecherInp \n{\n    width: 100%;\n    padding: 1vh 1vh 1vh 1vh;\n    margin: 0px 1vh 0px 1vh;\n    border-radius: 2vh;\n    height: auto;\n    border: 0;    \n}\n.DegreeUpload{\n    display: flex;\n    width: 40%;\n    height: 10%;\n    border-radius: 1vh;\n    border: 2px dotted;\n    padding: 2%;\n    background-color:rgb(238, 237, 237);\n    text-align: center;\n    cursor: pointer;\n    overflow: hidden;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.education\n{\n    display: flex;\n    flex-wrap: wrap;\n    width: 50%;\n}\n.EditTecherInp{\n    margin: 1vh 0 1vh 0;\n}\n\n.tableInfo\n{\n    display: flex;\n    background-color: #34979c;\n    height: auto;\n    width: 94%;\n    margin-left: 4%;\n    border-radius: 2vh;\n}\n@media screen and (max-width: 1000px) \n  {\n      .edit-heading\n      {\n          text-align: center;\n          margin-left: 0;\n      }\n      .TeacherComponents\n      {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n      }\n      .TeacherBankDetails,.meetLink,.courses,.TeacherPersonalDetails\n      {\n        width: auto;\n        margin: 2% 0 2% 0;\n      }\n\n\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
